import { useQuery } from '@tanstack/react-query';
import { fetchBuyerCompanies } from '@/api/orders';

function buildBuyerCompaniesQs(): string {
  return new URLSearchParams({
    isDropDown: 'true',
    includeOwnCompany: 'false',
  }).toString();
}

export const buyerCompaniesQueryOptions = {
  queryKey: ['cascade-tracing', 'buyer-companies'] as const,
  queryFn: () => fetchBuyerCompanies(buildBuyerCompaniesQs()),
  staleTime: 5 * 60_000,
};

export function useBuyerCompaniesDropdown() {
  return useQuery(buyerCompaniesQueryOptions);
}
